import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  AutocompleteModule,
  ComboModule,
  DaterangepickerModule,
  DetailsModule,
  FilterModule,
  InputModule,
  OrdersModule,
  PaginationModule,
  SettingsModule,
  SharedModule,
  TableModule,
  TabsModule,
  ToolbarModule,
  ViewTableModule,
} from 'beyond-util';
import { IzvestajPrihodaPoEmisijamaComponent } from './izvestaj-prihoda-po-emisijama.component';
import { NgxSpinnerModule } from 'ngx-spinner';

@NgModule({
  imports: [
    CommonModule,
    TabsModule,
    FilterModule,
    DetailsModule,
    PaginationModule,
    OrdersModule,
    SettingsModule,
    ToolbarModule,
    TableModule,
    ViewTableModule,
    SharedModule,
    DaterangepickerModule,
    AutocompleteModule,
    ComboModule,
    InputModule,
    NgxSpinnerModule,
  ],
  declarations: [IzvestajPrihodaPoEmisijamaComponent],
  exports: [IzvestajPrihodaPoEmisijamaComponent],
  entryComponents: [IzvestajPrihodaPoEmisijamaComponent],
})
export class IzvestajPrihodaPoEmisijamaModule {}



// WEBPACK FOOTER //
// ./src/app/pages/izvestaji/izvestaj-prihoda-po-emisijama/izvestaj-prihoda-po-emisijama.module.ts